import { useState } from "react";
import DisplayModels from "./DisplayModels";
import CreateModel from "./CreateModel";

export default function ModelLayout({ models }) {
  const [activeTab, setActiveTab] = useState("display");

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      {/* Page Header */}
      <header className="mb-8">
        <h1 className="text-2xl md:text-3xl font-bold text-ktx-purple">
          Model Management
        </h1>
        <p className="mt-2 text-gray-600">
          View, create, and manage your fine-tuned AI models
        </p>
      </header>

      {/* Tab Navigation */}
      <div className="bg-white rounded-lg shadow-sm mb-8">
        <div className="border-b border-gray-200">
          <nav className="flex -mb-px">
            <button
              onClick={() => setActiveTab("display")}
              className={`px-5 py-4 font-medium text-sm border-b-2 ${activeTab === "display"
                  ? "border-ktx-purple text-ktx-purple"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                } focus:outline-none transition duration-150 ease-in-out`}
            >
              <div className="flex items-center">
                <svg
                  className="mr-2 h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 10h16M4 14h16M4 18h16"
                  />
                </svg>
                View Models
              </div>
            </button>

            <button
              onClick={() => setActiveTab("create")}
              className={`ml-8 px-5 py-4 font-medium text-sm border-b-2 ${activeTab === "create"
                  ? "border-ktx-purple text-ktx-purple"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                } focus:outline-none transition duration-150 ease-in-out`}
            >
              <div className="flex items-center">
                <svg
                  className="mr-2 h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  />
                </svg>
                Create New Model
              </div>
            </button>
          </nav>
        </div>
      </div>

      {/* Active Component */}
      <div className="transition-opacity duration-300">
        {activeTab === "display" ? (
          <DisplayModels models={models} />
        ) : (
          <CreateModel onModelCreated={() => setActiveTab("display")} />
        )}
      </div>
    </div>
  );
}